import React, { useState } from 'react';
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Collapse,
    makeStyles,
    createStyles,
    Theme,
    Hidden,
    IconButton,
    Tooltip
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import HomeIcon from '@material-ui/icons/Home';
import SecurityIcon from '@material-ui/icons/Security';
import FolderIcon from '@material-ui/icons/Folder';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import { useDispatch, useSelector } from 'react-redux';
import { setView, _view } from '../redux/appSlice';
import HeaderLogo from './ui/HeaderLogo';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: 'transparent',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },

        drawerHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '4px 8px 4px 0'
        },

        drawerTitle: {
            fontSize: '13px',
            fontWeight: 600,
            color: '#1a1a1a',
            letterSpacing: '0.04em'
        },

        listItem: {
            borderRadius: '8px',
            margin: '1px 8px',
            width: 'calc(100% - 16px)',
            padding: '7px 10px',
            transition: 'background 0.15s',
            color: '#303030',

            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        },

        listItemSelected: {
            borderRadius: '8px',
            margin: '1px 8px',
            width: 'calc(100% - 16px)',
            padding: '7px 10px',
            backgroundColor: '#E1F5EE !important',
            color: '#085041',
            fontWeight: 500,

            '&:hover': {
                backgroundColor: '#d0ede4 !important'
            }
        },

        listItemIcon: {
            minWidth: '32px',
            color: '#aaaaaa'
        },

        listItemIconSelected: {
            minWidth: '32px',
            color: '#0F6E56'
        },

        listItemText: {
            '& span': {
                fontSize: '15px',
                fontWeight: 400,
                color: 'inherit'
            }
        },

        listItemTextSelected: {
            '& span': {
                fontSize: '15px',
                fontWeight: 500,
                color: '#085041'
            }
        },

        credentialItem: {
            borderRadius: '8px',
            margin: '1px 8px',
            width: 'calc(100% - 16px)',
            padding: '7px 10px',
            transition: 'background 0.15s',
            color: '#303030',

            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        },

        credentialItemSelected: {
            borderRadius: '8px',
            margin: '1px 8px',
            width: 'calc(100% - 16px)',
            padding: '7px 10px',
            backgroundColor: '#E1F5EE !important',
            color: '#085041',
            fontWeight: 500,

            '&:hover': {
                backgroundColor: '#d0ede4 !important'
            }
        },

        credentialIcon: {
            minWidth: '32px',
            color: '#aaaaaa'
        },

        credentialIconSelected: {
            minWidth: '32px',
            color: '#0F6E56'
        },

        credentialText: {
            '& span': {
                fontSize: '15px',
                fontWeight: 400,
                color: 'inherit'
            }
        },

        credentialTextSelected: {
            '& span': {
                fontSize: '15px',
                fontWeight: 500,
                color: '#085041'
            }
        },

        folderItem: {
            borderRadius: '8px',
            margin: '1px 8px',
            width: 'calc(100% - 16px)',
            padding: '7px 10px',
            color: '#555555',

            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        },

        folderIcon: {
            minWidth: '32px',
            color: '#aaaaaa'
        },

        folderText: {
            '& span': {
                fontSize: '15px',
                fontWeight: 400,
                color: 'inherit'
            }
        },

        chevron: {
            fontSize: '16px',
            color: '#aaaaaa',
            marginLeft: 'auto'
        },

        nestedItem: {
            borderRadius: '8px',
            margin: '2px 8px 2px 28px',
            width: 'calc(100% - 36px)',
            padding: '10px 14px 10px 22px',
            transition: 'background 0.15s',
            color: '#303030',

            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        },

        nestedItemSelected: {
            borderRadius: '8px',
            margin: '2px 8px 2px 28px',
            width: 'calc(100% - 36px)',
            padding: '10px 14px 10px 22px',
            backgroundColor: '#E1F5EE !important',
            color: '#085041',
            fontWeight: 500,

            '&:hover': {
                backgroundColor: '#d0ede4 !important'
            }
        },

        dot: {
            fontSize: '8px',
            color: '#1D9E75',
            marginLeft: 'auto'
        },

        primarySection: {
            padding: '8px 0 6px'
        },

        otherSection: {
            padding: '0px 0'
        },

        collapsedItem: {
            borderRadius: '10px',
            margin: '2px 8px',
            padding: '10px',
            display: 'flex',
            justifyContent: 'center',
            width: 'calc(100% - 16px)',
            minWidth: 0,
            transition: 'background 0.15s',
            color: '#303030',

            '&:hover': {
                backgroundColor: '#f5f5f5'
            }
        },

        collapsedItemSelected: {
            borderRadius: '10px',
            margin: '2px 8px',
            padding: '10px',
            display: 'flex',
            justifyContent: 'center',
            width: 'calc(100% - 16px)',
            minWidth: 0,
            backgroundColor: '#E1F5EE !important',
            color: '#0F6E56',

            '&:hover': {
                backgroundColor: '#d0ede4 !important'
            }
        },

        collapseToggle: {
            marginTop: 'auto',
            display: 'flex',
            padding: '8px',
            paddingTop: '0px',
            justifyContent: 'flex-end'
        },

        collapseToggleCollapsed: {
            marginTop: 'auto',
            display: 'flex',
            padding: '8px',
            paddingTop: '0px',
            justifyContent: 'center'
        }
    })
);

const primaryItem = {
    label: 'Credential Studio',
    view: 4,
    Icon: SecurityIcon
};

const otherItems = [
    { label: 'Create', view: 1 },
    { label: 'Create HD', view: 2 },
    { label: 'Resolve', view: 3 },
    { label: 'Create offchain', view: 5 },
    { label: 'Resolve offchain', view: 6 }
];

interface DrawerItemsProps {
    onNavigate?: () => void;
    onClose?: () => void;
    collapsed?: boolean;
    onToggleCollapse?: () => void;
}

export default function DrawerItems({
    onNavigate,
    onClose,
    collapsed,
    onToggleCollapse
}: DrawerItemsProps) {
    const dispatch = useDispatch();
    const classes = useStyles();

    const view = useSelector(_view);

    const [folderOpen, setFolderOpen] = useState(false);

    const isSelected = (v: number) => view === v;

    const navigate = (v: number) => {
        if (onNavigate) {
            onNavigate();
            setTimeout(() => dispatch(setView(v)), 280);
        } else {
            dispatch(setView(v));
        }
    };

    const didToolsActive = otherItems.some((i) => isSelected(i.view));

    return (
        <div className={classes.root}>
            {/* Header */}
            <div className={classes.drawerHeader}>
                <Hidden smUp>
                    <HeaderLogo />
                </Hidden>
                <Hidden smUp>
                    <IconButton size="small" onClick={onClose} style={{ color: '#5F6F81' }}>
                        <CloseIcon style={{ fontSize: 25 }} />
                    </IconButton>
                </Hidden>
            </div>

            {collapsed ? (
                <>
                    <Tooltip title="Home" placement="right">
                        <ListItem
                            button
                            className={
                                isSelected(0)
                                    ? classes.collapsedItemSelected
                                    : classes.collapsedItem
                            }
                            onClick={() => navigate(0)}>
                            <HomeIcon
                                fontSize="small"
                                style={{ color: isSelected(0) ? '#0F6E56' : '#aaaaaa' }}
                            />
                        </ListItem>
                    </Tooltip>

                    <Tooltip title="Credential Studio" placement="right">
                        <ListItem
                            button
                            className={
                                isSelected(primaryItem.view)
                                    ? classes.collapsedItemSelected
                                    : classes.collapsedItem
                            }
                            onClick={() => navigate(primaryItem.view)}>
                            <primaryItem.Icon
                                fontSize="small"
                                style={{
                                    color: isSelected(primaryItem.view) ? '#0F6E56' : '#aaaaaa'
                                }}
                            />
                        </ListItem>
                    </Tooltip>

                    <Tooltip title="DID Tools — click to expand" placement="right">
                        <ListItem
                            button
                            className={
                                didToolsActive
                                    ? classes.collapsedItemSelected
                                    : classes.collapsedItem
                            }
                            onClick={onToggleCollapse}>
                            <FolderIcon
                                fontSize="small"
                                style={{ color: didToolsActive ? '#0F6E56' : '#aaaaaa' }}
                            />
                        </ListItem>
                    </Tooltip>
                </>
            ) : (
                <>
                    {/* Home */}
                    <List disablePadding className={classes.primarySection}>
                        <ListItem
                            button
                            className={isSelected(0) ? classes.listItemSelected : classes.listItem}
                            onClick={() => navigate(0)}>
                            <ListItemIcon
                                className={
                                    isSelected(0)
                                        ? classes.listItemIconSelected
                                        : classes.listItemIcon
                                }>
                                <HomeIcon fontSize="small" />
                            </ListItemIcon>

                            <ListItemText
                                primary="Home"
                                className={
                                    isSelected(0)
                                        ? classes.listItemTextSelected
                                        : classes.listItemText
                                }
                            />

                            {isSelected(0) && <FiberManualRecordIcon className={classes.dot} />}
                        </ListItem>
                    </List>

                    {/* Credential Studio */}
                    <List disablePadding className={classes.primarySection}>
                        <ListItem
                            button
                            className={
                                isSelected(primaryItem.view)
                                    ? classes.credentialItemSelected
                                    : classes.credentialItem
                            }
                            onClick={() => navigate(primaryItem.view)}>
                            <ListItemIcon
                                className={
                                    isSelected(primaryItem.view)
                                        ? classes.credentialIconSelected
                                        : classes.credentialIcon
                                }>
                                <primaryItem.Icon fontSize="small" />
                            </ListItemIcon>

                            <ListItemText
                                primary={primaryItem.label}
                                className={
                                    isSelected(primaryItem.view)
                                        ? classes.credentialTextSelected
                                        : classes.credentialText
                                }
                            />

                            {isSelected(primaryItem.view) && (
                                <FiberManualRecordIcon className={classes.dot} />
                            )}
                        </ListItem>
                    </List>

                    {/* DID Tools Folder */}
                    <List disablePadding className={classes.otherSection}>
                        <ListItem
                            button
                            className={classes.folderItem}
                            onClick={() => setFolderOpen(!folderOpen)}>
                            <ListItemIcon className={classes.folderIcon}>
                                {folderOpen ? (
                                    <FolderOpenIcon fontSize="small" />
                                ) : (
                                    <FolderIcon fontSize="small" />
                                )}
                            </ListItemIcon>

                            <ListItemText primary="DID Tools" className={classes.folderText} />

                            {folderOpen ? (
                                <ExpandMoreIcon className={classes.chevron} />
                            ) : (
                                <ChevronRightIcon className={classes.chevron} />
                            )}
                        </ListItem>

                        <Collapse in={folderOpen} timeout="auto" unmountOnExit>
                            <List disablePadding>
                                {otherItems.map(({ label, view: v }) => (
                                    <ListItem
                                        button
                                        key={label}
                                        className={
                                            isSelected(v)
                                                ? classes.nestedItemSelected
                                                : classes.nestedItem
                                        }
                                        onClick={() => navigate(v)}>
                                        <ListItemText
                                            primary={label}
                                            className={
                                                isSelected(v)
                                                    ? classes.listItemTextSelected
                                                    : classes.listItemText
                                            }
                                        />
                                        {isSelected(v) && (
                                            <FiberManualRecordIcon className={classes.dot} />
                                        )}
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </List>
                </>
            )}

            <Hidden xsDown>
                <div
                    className={
                        collapsed ? classes.collapseToggleCollapsed : classes.collapseToggle
                    }>
                    <Tooltip
                        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                        placement="right">
                        <IconButton
                            size="small"
                            onClick={onToggleCollapse}
                            style={{ color: '#aaaaaa' }}>
                            {collapsed ? (
                                <LastPageIcon fontSize="small" />
                            ) : (
                                <FirstPageIcon fontSize="small" />
                            )}
                        </IconButton>
                    </Tooltip>
                </div>
            </Hidden>
        </div>
    );
}
